export const DropDownMenu = 'atlantis-drop-down-menu';
export const DropDownMenuItem = 'atlantis-drop-down-menu-item';